import { castArray, gen, genId, months, statusOptions, VueDate } from '../../views/utils'

// null: 'Unknown status',
// 1: 'Waiting for parts',
// 2: 'In progress',
// 3: 'Done (not paid)',
// 4: 'Done & Paid',

export default {
  auto: '*',

  store: {
    state: {
      contextEvents: [],
    },

    getters: {
      _importEvents: () => event => ({
        ...event,
        datetime: VueDate(event.datetime),
      }),

      eventlist: state => state.contextEvents,

      months: () => months.map((month, index) => [index, month]),

      eventsStatuses: () => ({
        null: { name: 'No status', theme: 'neutral' },
        1: { name: 'Waiting for parts', theme: 'warning' },
        2: { name: 'In progress', theme: 'info' },
        3: { name: 'Done (not paid)', theme: 'success' },
        4: { name: 'Done & Paid', theme: 'success' },
      }),
      eventsStatusOptions: statusOptions('eventsStatuses', { nullAs: false }),

      genEvent: gen(() => ({
        id: genId(),
        description: '',
        datetime: VueDate((date) => {
          date.setMinutes(0)
          date.setSeconds(0)
          date.setMilliseconds(0)
          return date
        }),
        jobcardId: null,
        workerId: 9,
        status: null,
        time: 60,
      }))
    },

    actions: {
      POP_EVENTLIST({ commit }, index = 0) {
        commit('POP_EVENTLIST', index)
      },
      PUSH_EVENTLIST({ commit, getters }, event = {}) {
        commit('PUSH_EVENTLIST', getters.genEvent(event))
      },
      RESET_EVENTLIST({ commit, dispatch }, event = {}) {
        commit('RESET_EVENTLIST')
        commit('RESET_JOBLIST')
        dispatch('PUSH_EVENTLIST', event)
      },
      SET_EVENTLIST({ commit }, eventlist) {
        commit('SET_EVENTLIST', eventlist)
      },
    },

    mutations: {
      POP_EVENTLIST(state, index) {
        state.contextEvents.splice(index, 1)
      },
      PUSH_EVENTLIST(state, events) {
        state.contextEvents.push(...castArray(events))
      },
      RESET_EVENTLIST(state) {
        state.contextEvents = []
      },
      SET_EVENTLIST(state, eventlist) {
        state.contextEvents = eventlist
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js